import gql from 'graphql-tag'

import { Mutation } from '../types-graphql'

export type TDataDownloadUsers = Pick<Mutation, 'downloadUsers'>
export const DOWNLOAD_USERS = gql`
  mutation ($input: DownloadUsersInput!) {
    downloadUsers(input: $input) {
      generating
    }
  }
`
